import { FacilitiesDetailSeaBurialContainer } from "@/containers/FacilitiesSeaBurialContainer";
import {
  GetStaticPaths,
  GetStaticPathsResult,
  GetStaticProps,
  InferGetStaticPropsType,
} from "next";
import seaburials from "@/constants/sea_burial_detail.json";
import { ParsedUrlQuery } from "querystring";

import { skipDevBuildInGetStaticPaths } from "@/utils/skipDevBuildInGetStaticPaths";

export const getStaticPaths: GetStaticPaths = async () => {
  const skipBuildResult = skipDevBuildInGetStaticPaths() as GetStaticPathsResult;
  if (skipBuildResult) {
    return skipBuildResult;
  }

  const seaBurialRegionPath = seaburials.map((res) => {
    return {
      params: {
        id: String(res.id),
      },
    };
  });

  return {
    paths: seaBurialRegionPath,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const { id } = params as ParsedUrlQuery;

  const seaBurialData = seaburials.find((res) => res.id === Number(id));

  let packagePriceString;
  let description = "";
  let companyname = "";

  if (seaBurialData) {
    companyname = seaBurialData.companyname;

    packagePriceString = seaBurialData.packages.map((res) => {
      return `${res.name}: ${res.price.toLocaleString()}원`;
    });
    description = `${seaBurialData.companyname} 정보, 비용, 할인 안내, ${seaBurialData.fulladdress}, ${seaBurialData.companyname} 비용 ${packagePriceString}`;
  }

  return {
    props: {
      seaBurialData,
      pageDescription: description,
      pageOgDescription: description,
      pageKeywords: `${companyname}, ${companyname} 사진, ${companyname} 가격, ${companyname} 위치, ${companyname} 후기, ${companyname} 정보, 장지검색, 해양장, 인천바다장,인천해양장,인천 해양장,유골뿌리기,화장후유골,화장후 유골,유골,푸른바다장,푸른 바다장,인천 바다장, 부산바다장, 부산해양장`,
      pageOgTitle: `${companyname}, 바다장(해양장) 비용, 견적, 후기, 정보 - [장례의 모든 것, 고이장례연구소]`,
    },
  };
};

export default function SeaBurialDetail({
  seaBurialData,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return <FacilitiesDetailSeaBurialContainer seaBurialData={seaBurialData} />;
}
